import { useState } from "react";
import { apiClient } from "../lib/api";
import { FileUploader } from "./components/FileUploader";
import { IllustrationList } from "./components/IllustrationList";
import { Sidebar } from "./components/Sidebar";
import { TagManager } from "./components/TagManager";
import { AuthWrapper } from "./components/AuthWrapper";
import { AboutManager } from "./components/AboutManager";
import { LayoutSections } from "./components/LayoutSections";
import { ImagePlacementManager } from "./components/ImagePlacementManager";
import { WorksManagement } from "./components/WorksManagement";
import { WorksPlacementManager } from "./components/WorksPlacementManager";

const MENU_ITEMS = [
  { id: "upload", label: "アップロード" },
  { id: "illustrations", label: "イラスト一覧" },
  { id: "tags", label: "タグ管理" },
  { id: "about", label: "aboutセクション" },
  { id: "sections", label: "レイアウト登録" },
  { id: "placements", label: "画像配置" },
  { id: "works", label: "作品カテゴリー管理" },
  { id: "worksPlacement", label: "作品配置" },
];

export const Admin = () => {
  const [activeMenu, setActiveMenu] = useState("upload");
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = async (
    file: File,
    category: string,
    title: string,
    tagIds: number[]
  ) => {
    try {
      setIsUploading(true);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("category", category);
      formData.append("title", title);
      formData.append("tag_ids", JSON.stringify(tagIds));

      const result = await apiClient.upload("/upload", formData);
      console.log("Upload result:", result);

    } catch (error) {
      console.error("Upload error:", error);
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  const renderContent = () => {
    switch (activeMenu) {
      case "upload":
        return (
          <FileUploader onUpload={handleUpload} isUploading={isUploading} />
        );
      case "illustrations":
        return <IllustrationList />;
      case "tags":
        return <TagManager />;
      case "about":
        return <AboutManager />;
      case "sections":
        return <LayoutSections />;
      case "placements":
        return <ImagePlacementManager />;
      case "works":
        return <WorksManagement />;
      case "worksPlacement":
        return <WorksPlacementManager />;
      default:
        return null;
    }
  };

  return (
    <AuthWrapper>
      <div className="flex">
        <Sidebar
          items={MENU_ITEMS}
          activeItem={activeMenu}
          onItemClick={setActiveMenu}
        />
        <main className="flex-1 p-8 bg-gray-100 min-h-screen">
          {renderContent()}
        </main>
      </div>
    </AuthWrapper>
  );
};
